import { QUERY_KEYS } from '@/constants/reactQueryKeys'
import { useQueryWithHandler } from '@/hooks/useQueryWithHandler'
import {
    getWafFreeReport,
    type Paginated,
    type WafFreeReportParams,
    type WaapServiceRow,
} from '../services'

/**
 * Danh sách dịch vụ WAF (WAAP) cross-org từ servicemgmt.
 * Lỗi hiển thị dạng alert thay vì nuốt trang: 403 ở đây nghĩa là tài khoản
 * không thuộc group /Admin, người dùng cần biết lý do.
 */
export const useWafFreeReport = (params: WafFreeReportParams) => {
    return useQueryWithHandler<Paginated<WaapServiceRow>>(
        {
            queryKey: [QUERY_KEYS.WAF_FREE_REPORT, params],
            queryFn: () => getWafFreeReport(params),
            placeholderData: true,
        },
        { errorDisplayMode: 'alert' }
    )
}
